import { BRAND_STATUS_V2 } from '../../../types/brand/common';

export const BRAND_STATUS_LABEL_V2 = {
  [BRAND_STATUS_V2.REQUEST_JOIN]: '가입 요청',
  [BRAND_STATUS_V2.REJECT]: '승인 거절',
  [BRAND_STATUS_V2.ACTIVE]: '활성',
  [BRAND_STATUS_V2.INACTIVE]: '비활성',
};

export const BRAND_STATUS_SELECT_LIST_V2 = Object.values(BRAND_STATUS_V2).map((status) => ({
  id: status,
  name: BRAND_STATUS_LABEL_V2[status],
}));
